<template>
  <el-dialog :visible.sync="dialogVisible" title="Select random winners">
    <p>
      This will allow you to select a set of random winners for your campaign.
      It will randomly select a set of messages that was sent into this campaign based on
      the parameters you define below.
    </p>
    <el-form label-width="120px" :model="form" :rules="rules">
      <el-form-item label="File name" prop="fileName">
        <el-input v-model="form.fileName" />
      </el-form-item>
      <el-form-item label="Dates" prop="rangeDate">
        <el-date-picker
          type="datetimerange"
          range-separator="To"
          start-placeholder="Start date"
          end-placeholder="End date"
          :picker-options="pickerOptions"
          v-model="form.rangeDate"
        />
      </el-form-item>
      <el-form-item label="Winners" prop="winners">
        <el-input-number v-model="form.winners" />
      </el-form-item>
      <el-form-item label="Unique" prop="uniqueWinners">
        <el-switch v-model="form.uniqueWinners" />
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel" :disabled="isLoading">Cancel</el-button>
      <el-button type="primary" @click="handleRunRandomSelection" :disabled="isLoading">
        <i class="fa fa-spinner fa-spin" v-show="isLoading"></i>
        Select
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'RandomSelectDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    campaignId: {
      type: Number,
      requied: true,
    },
  },
  data: () => ({
    form: {
      fileName: '',
      rangeDate: [],
      uniqueWinners: false,
      winners: 1,
    },
    rules: {
      fileName: [
        { required: true, trigger: 'blur', message: 'Please enter a filename for this selection.' },
      ],
      rangeDate: [{ required: true, trigger: 'blur', message: 'Please enter a date range.' }],
    },
    pickerOptions: {
      disabledDate(time) {
        return time.getTime() > Date.now();
      },
    },
    isLoading: false,
  }),
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visibility) {
        this.$emit('onVisibleChanged', visibility);
      },
    },
  },
  methods: {
    handleRunRandomSelection() {
      const payload = {
        campaign: this.campaignId,
        file_name: this.form.fileName,
        range_date: this.form.rangeDate,
        unique_winners_flag: this.form.uniqueWinners,
        winners: this.form.winners,
      };
      this.isLoading = true;
      this.$forceUpdate();
      return this.$store
        .dispatch('campaign/runRandomSelector', payload)
        .then(data => {
          this.$emit('onVisibleChanged', false);
          this.isLoading = false;
          const isEmpty = !Object.values(data.data.selections).some(x => x !== null && x !== '');
          if (isEmpty) {
            // this.warningMessage();
          }
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    warningMessage() {
      this.$notify({
        title: 'Warning',
        message: 'There are no interactions within the requested time range',
        type: 'warning',
      });
    },
    handleCancel() {
      this.$emit('onVisibleChanged', false);
    },
  },
};
</script>



// WEBPACK FOOTER //
// RandomSelectDialog.vue?7eb929ab